import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import AddEditTenant from "../../Sections/Tenant/AddEditTenant";

const TenantAddEditComponent = () => {
  return <Dashboard sectionName={<AddEditTenant />} />;
};

export default TenantAddEditComponent;
